import React from 'react'
import { Card } from 'reactstrap'
import Approval from '../../assets/Approval'
import { useSearchParams } from 'react-router-dom'

const OrderApproval = () => {
  const [searchParams] = useSearchParams()

  const orderId = searchParams.get('orderId')

  return (
    <div className='min-vh-100 d-flex justify-content-center align-items-center'>
      <Card className='w-100 m-3' style={{ maxWidth: '1300px' }}>
        <main className='text-center p-4'>
          <Approval />
          <section>
            <h1 className='h4 mb-3 mt-4'>Success</h1>
            <p className='lead'>You have approved Pharmacy Order #{orderId}</p>
          </section>
        </main>
      </Card>
    </div>
  )
}

export default OrderApproval
